import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';
import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import SidebarMenu from './SidebarMenu';

export interface IComponentWrapperProps {
  children: React.ReactNode;
}

export default function ComponentWrapper(props: IComponentWrapperProps) {
  const [showMenu, setShowMenu] = React.useState(false);
  const [isDetailCategory, setDetailCategory] = React.useState(false);
  const [menuDetailCategory, setMenuDetailCategory] = React.useState('');

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (!showMenu) {
      setDetailCategory(false);
      setMenuDetailCategory('');
      document.body.style.overflow = 'unset';
    }
  }, [showMenu]);

  return (
    <div style={{ overflowX: 'hidden' }}>
      <SidebarMenuContext.Provider
        value={{
          menuShow: showMenu,
          toggleMenuShow: setShowMenu,
          onMenuDetail: isDetailCategory,
          toggleMenuDetail: setDetailCategory,
          menuDetailCategory,
          setMenuDetailCategory,
        }}
      >
        <div>{props.children}</div>
        <SidebarMenu show={showMenu} hide={() => setShowMenu(false)} />
      </SidebarMenuContext.Provider>
    </div>
  );
}
